import { Directive, HostListener, Input } from '@angular/core';
import { Router } from '@angular/router';

@Directive({
  selector: '[reloadPageLinkDirective]'
})
export class ReloadPageLinkDirective {
  @Input() routerLink: string;

  constructor(private router: Router) {}

  @HostListener('click', ['$event'])
  onClick(event): void {
    event.preventDefault();
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {     
      this.router.navigateByUrl(this.routerLink);
    });
  }
}
